"use client";
async function a(e, o, s) {
  const i = `${s}/events`, r = {
    ...e,
    type: e.eventName
  };
  if ("searchQuery" in e.properties)
    r.entityType = "search", r.searchQuery = e.properties.searchQuery;
  else if ("messageId" in e.properties)
    r.entityType = "message", r.messageId = e.properties.messageId;
  else {
    if (r.entityType = "conversation", !e.properties.conversation) return;
    r.conversationId = e.properties.conversation.id;
  }
  const t = await fetch(i, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${o}`
    },
    body: JSON.stringify(r)
  });
  if (!t.ok) {
    const n = await t.text();
    throw new Error(`Failed to log event: ${n}`);
  }
}
export {
  a as logEvent
};
